module.exports = __webpack_public_path__ + "img/background.83eaf574.jpg";